import './styles/main.css';
import { fixture } from './data/fixtures.js';
import { verifyFixture } from './data/model.js';
import { navigate, parseRoute } from './router.js';
import { aboutView, recordView, workcardView } from './views/details.js';
import { commercialView, customersView, invoicesView, materialView } from './views/lists.js';
import { overviewView } from './views/overview.js';
import { elbStoryView, kitaWorkflowView, stockStoryView } from './views/workflow.js';
import { appShell } from './views/shared.js';

const REQUEST_KEY = 'nordwerk-demo-request';
const app = document.querySelector('#app');

function requestText() {
  return sessionStorage.getItem(REQUEST_KEY) || fixture.kita.defaultRequest;
}

function viewFor(route) {
  if (route.view === 'overview') return overviewView();
  if (route.view === 'customers') return customersView();
  if (route.view === 'commercial') return commercialView();
  if (route.view === 'material') return materialView();
  if (route.view === 'invoices') return invoicesView();
  if (route.view === 'record') return recordView(route);
  if (route.view === 'workcard') return workcardView();
  if (route.view === 'about') return aboutView();
  if (route.view === 'workflow' && route.story === 'stock') return stockStoryView();
  if (route.view === 'workflow' && route.story === 'elb') return elbStoryView();
  return kitaWorkflowView(route, requestText());
}

function render() {
  const route = verifyFixture() ? parseRoute(location.search) : { view: 'overview' };
  app.innerHTML = appShell(viewFor(route), route);
  document.title = `NordWerk · ${route.view === 'overview' ? 'Übersicht' : 'Besucher-Demo'}`;
  window.scrollTo(0, 0);
}

document.addEventListener('click', (event) => {
  const anchor = event.target.closest('a[data-route]');
  if (anchor && anchor.origin === location.origin) {
    event.preventDefault();
    history.pushState({}, '', anchor.href);
    render();
    document.querySelector('#content')?.focus();
    return;
  }
  if (event.target.closest('[data-reset-request]')) {
    sessionStorage.removeItem(REQUEST_KEY);
    const textarea = document.querySelector('#request-text');
    if (textarea) textarea.value = fixture.kita.defaultRequest;
  }
  if (event.target.closest('[data-print]')) window.print();
});

document.addEventListener('submit', (event) => {
  if (event.target.id !== 'request-form') return;
  event.preventDefault();
  const value = document.querySelector('#request-text').value.trim() || fixture.kita.defaultRequest;
  sessionStorage.setItem(REQUEST_KEY, value);
  navigate({ view: 'workflow', story: 'kita', step: 2 });
});

window.addEventListener('popstate', render);
render();

